import { createSlice } from '@reduxjs/toolkit'

const paymentVerifySlice = createSlice({
    name: 'paymentVerify',
    initialState: { order: {}, failReferenceNumber: null },
    reducers: {
        verifyPaymentStart() {},
        setOrder(state, action) {
            const { payload } = action
            state.order = payload
        },
        setFailReferenceNumber(state, action) {
            const { payload } = action
            state.failReferenceNumber = payload
        },
    },
})

const { actions, reducer } = paymentVerifySlice

export const { verifyPaymentStart, setOrder, setFailReferenceNumber } = actions

export default reducer
